module.exports = require("remark-contributors");


//////////////////
// WEBPACK FOOTER
// external "remark-contributors"
// module id = 55
// module chunks = 0 1 2 3 4 5 6 7 8 9 12 13